import { downloadSubmission, downloadAllSubmissions } from '../../../service';

export const downloadSubmissionPdf = async (submissionId) => {
  await downloadSubmission(submissionId);
};

export const downloadAllSubmissionsZip = async (assignmentId) => {
  await downloadAllSubmissions(assignmentId);
};
